export var DEFAULT_OPTIONS = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
            display: true,
            align: 'end',
            labels: {
                usePointStyle: true,
            },
        },
        datalabels: {
            anchor: 'end',
            align: 'center',
            formatter: Math.round,
            display: false,
        },
    },
};
